import WarningErrorIcon from '@core/components/icons/WarningErrorIcon'
import React, { useId } from 'react'
import clsx from 'clsx'
import './ApplyV2InputTextarea.scss'

interface Props {
    value?: string
    label?: string
    onChange?: React.ChangeEventHandler<HTMLTextAreaElement>
    onFocus?: React.FocusEventHandler<HTMLTextAreaElement>
    onBlur?: React.FocusEventHandler<HTMLTextAreaElement>
    isDisabled?: boolean
    className?: string
    id?: string | number
    name?: string
    isLoading?: boolean
    errorMessage?: string | null | boolean
    children?: React.ReactNode
    isRequired?: boolean
    placeholder?: string
    maxLength?: number
    minLength?: number
    autoFocus?: boolean
    rows?: number
    isShowErrorMessage?: boolean
}

const baseClass = 'ApplyV2InputTextarea'

function ApplyV2InputTextarea({
    value = '',
    label,
    onChange,
    onFocus,
    onBlur,
    isDisabled = false,
    className = '',
    id,
    name,
    isLoading = false,
    errorMessage,
    children,
    isRequired = false,
    placeholder = '',
    maxLength,
    minLength,
    autoFocus,
    rows = 3,
    isShowErrorMessage = true,
}: Props) {
    const defaultId = useId()
    return (
        <div
            className={clsx(baseClass, className, {
                [`${baseClass}--error`]: !!errorMessage,
                [`${baseClass}--disabled`]: isDisabled,
                [`${baseClass}--loading`]: isLoading,
            })}
        >
            {label && (
                <label className={`${baseClass}__label`} htmlFor={id ? id.toString() : defaultId}>
                    {label}
                    {isRequired && '*'}
                </label>
            )}
            <div
                className={clsx(`${baseClass}__textarea-wrapper`, {
                    [`${className}__textarea-wrapper`]: className,
                    [`${baseClass}__textarea-wrapper--disabled`]: isDisabled,
                    [`${baseClass}__textarea-wrapper--loading`]: isLoading,
                    [`${baseClass}__textarea-wrapper--error`]: !!errorMessage,
                    [`${className}__textarea-wrapper--disabled`]: className && isDisabled,
                    [`${className}__textarea-wrapper--loading`]: className && isLoading,
                    [`${className}__textarea-wrapper--error`]: className && !!errorMessage,
                })}
            >
                <textarea
                    id={id ? id.toString() : defaultId}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    disabled={isDisabled}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    minLength={minLength}
                    autoFocus={autoFocus}
                    rows={rows}
                    className={clsx(`${baseClass}__textarea`, {
                        [`${baseClass}__textarea--error`]: !!errorMessage,
                        [`${baseClass}__textarea--loading`]: isLoading,
                        [`${className}__textarea--error`]: className && !!errorMessage,
                        [`${className}__textarea--loading`]: className && isLoading,
                    })}
                />
                {isLoading && (
                    <div className={`${baseClass}__loading-indicator`}>
                        <div className={`${baseClass}__spinner`}></div>
                    </div>
                )}
            </div>
            {errorMessage && isShowErrorMessage && (
                <div
                    className={clsx(`${baseClass}__error`, {
                        [`${className}__error`]: className,
                    })}
                >
                    <div
                        className={clsx(`${baseClass}__error--icon`, {
                            [`${className}__error--icon`]: className,
                        })}
                    >
                        <WarningErrorIcon />
                    </div>
                    <div
                        className={clsx(`${baseClass}__error--text`, {
                            [`${className}__error--text`]: className,
                        })}
                    >
                        {errorMessage}
                    </div>
                </div>
            )}
        </div>
    )
}

export default ApplyV2InputTextarea
